import type { UIMessage } from 'ai';

/** A single part from a UIMessage */
export type MessagePart = UIMessage['parts'][number];

// == Type guards for specific part types ==

/** Type guard for reasoning parts */
export function isReasoningPart(part: MessagePart): part is { type: 'reasoning'; text: string } {
  return part.type === 'reasoning' && 'text' in part && typeof part.text === 'string';
}

/** Type guard for text parts */
export function isTextPart(part: MessagePart): part is { type: 'text'; text: string } {
  return part.type === 'text' && 'text' in part && typeof part.text === 'string';
}

/** Type guard for dynamic-tool parts */
export function isDynamicToolPart(
  part: MessagePart
): part is Extract<MessagePart, { type: 'dynamic-tool' }> {
  return part.type === 'dynamic-tool';
}

/** Type guard for static tool parts (tool-*) */
export function isStaticToolPart(part: MessagePart): boolean {
  return typeof part.type === 'string' && part.type.startsWith('tool-') && 'state' in part;
}
